import { render, staticRenderFns } from "./sound.vue?vue&type=template&id=06f0be27&scoped=true&"
import script from "./sound.vue?vue&type=script&lang=js&"
export * from "./sound.vue?vue&type=script&lang=js&"
import style0 from "./sound.vue?vue&type=style&index=0&id=06f0be27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f0be27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f0be27')) {
      api.createRecord('06f0be27', component.options)
    } else {
      api.reload('06f0be27', component.options)
    }
    module.hot.accept("./sound.vue?vue&type=template&id=06f0be27&scoped=true&", function () {
      api.rerender('06f0be27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/sound.vue"
export default component.exports